<template>
    <div class="mesin-edc-content">
        <SOSlotBase :container-name="'mesin-list-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="getTitle" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16" v-if="formReady">
                    <div class="form-field p-x-20">
                        <form class="mesin-edc">
                            <div class="form-group">
                                <SOInputRegular
                                    :title="'Kode Akun'"
                                    :placeholder="'1.02.004'"
                                    :readonly="true"
                                    v-model="posted.idakun_keuangan_edc"
                                />
                                <label class="m-d-0 f-12 f-c-midgrey f-regular">
                                    Kode akun disediakan otomatis oleh sistem.
                                </label>
                                <ErrorMessage
                                    class="error"
                                    label="Nama Mesin EDC"
                                    :validation="$v.posted.idakun_keuangan_edc"
                                />
                            </div>
                            <div class="form-group">
                                <SOInputRegular
                                    :title="'Nama Mesin EDC'"
                                    :placeholder="'Nama mesin...'"
                                    :required="true"
                                    v-model="posted.nama_mesin_edc"
                                />
                                <!-- @input="handleInput($event)" -->
                                <ErrorMessage
                                    class="error"
                                    label="Nama Mesin EDC"
                                    :validation="$v.posted.nama_mesin_edc"
                                />
                            </div>
                            <div class="form-group">
                                <SOInputSelect
                                    :required="true"
                                    :title="'Outlet'"
                                    :placeholder="'Pilih outlet'"
                                    :options="listOutlet"
                                    :selected="posted.idoutlet"
                                    @option-selected="optionSelected($event, 'idoutlet')"
                                />
                                <ErrorMessage class="error" label="Outlet" :validation="$v.posted.idoutlet" />
                            </div>
                            <div class="form-group">
                                <SOInputSelect
                                    :required="true"
                                    :title="'Provider'"
                                    :placeholder="'Pilih provider...'"
                                    :options="listProvider"
                                    :selected="posted.idprovider"
                                    @option-selected="optionSelected($event, 'idprovider')"
                                />
                                <ErrorMessage class="error" label="Provider" :validation="$v.posted.idprovider" />
                            </div>
                            <div class="form-group">
                                <SoModalOptions
                                    ref="modalAkun"
                                    :title="'Akun Settlement'"
                                    :selectedOption="posted.idakun_keuangan_settlement"
                                    :placeholder="'Pilih akun settlement'"
                                    :options="listSettlement"
                                    :id="'akun-settlement'"
                                    :required="true"
                                    :isBtnLink="true"
                                    :text-link="'Buat akun settlement baru...'"
                                    @linkAction="gotoAddAkun"
                                    @onSelected="onSelectedAkun($event, 'idakun_keuangan_settlement')"
                                />
                                <ErrorMessage
                                    class="error"
                                    label="Akun Settlement"
                                    :validation="$v.posted.idakun_keuangan_settlement"
                                />
                            </div>
                        </form>
                    </div>
                    <div class="separator"></div>
                    <div class="biaya-tambahan p-x-20 form-field" style="position: relative;">
                        <SOButtonExpand
                            id="biaya-tambahan"
                            text="Biaya tambahan (opsional)"
                            :full-height="280"
                            ref="menu_expanded"
                            @hook:mounted="onMounted('menu_expanded')"
                        >
                            <template v-slot:content>
                                <div>
                                    <form class="biaya-tambahan">
                                        <div class="form-group">
                                            <label class="m-d-0 f-16 f-c-black f-semi">Biaya Tambahan Transaksi</label>
                                            <label class="m-d-0 f-c-midgrey f-14 f-regular">
                                                Biaya tambahan yang dibebankan kepada konsumen saat melakukan pembayaran
                                                transaksi dengan mesin EDC.
                                            </label>
                                        </div>
                                        <SOTooltips>
                                            <template v-slot:tooltips>
                                                <div>
                                                    <Tooltips
                                                        keterangan="Konsumen membayar menggunakan provider yang sama dengan provider mesin EDC."
                                                        :percent="posted.persen_sesama_edc"
                                                    />
                                                </div>
                                            </template>
                                            <template v-slot:content>
                                                <div class="d-grid-12 m-d-12">
                                                    <div class="grid-cspan-8" style="align-self: center">
                                                        Sesama provider:
                                                    </div>
                                                    <div class="grid-cspan-4">
                                                        <SOInputNominal
                                                            ref="sesama_provider"
                                                            :prefix-right="true"
                                                            :use-comma="true"
                                                            :placeholder="'1'"
                                                            :id="`s-provider`"
                                                            :use-autocomplete="false"
                                                            :max-value="dpMax"
                                                            :prefix="`%`"
                                                            v-model="biaya.sesamaProvider"
                                                            @input="onNominalChange($event, 'persen_sesama_edc')"
                                                            @hook:mounted="onMounted('sesama_provider')"
                                                        />
                                                    </div>
                                                </div>
                                            </template>
                                        </SOTooltips>
                                        <SOTooltips>
                                            <template v-slot:tooltips>
                                                <div>
                                                    <Tooltips
                                                        keterangan="Konsumen membayar menggunakan provider yang berbeda dengan provider mesin EDC."
                                                        :percent="posted.persen_berbeda_provider"
                                                    />
                                                </div>
                                            </template>
                                            <template v-slot:content>
                                                <div class="d-grid-12 m-d-12">
                                                    <div class="grid-cspan-8" style="align-self: center">
                                                        Beda Provider:
                                                    </div>
                                                    <div class="grid-cspan-4 has-tooltip">
                                                        <SOInputNominal
                                                            ref="berbeda_provider"
                                                            :prefix-right="true"
                                                            :use-comma="true"
                                                            :placeholder="'1'"
                                                            :id="`b-provider`"
                                                            :use-autocomplete="false"
                                                            :max-value="dpMax"
                                                            :prefix="`%`"
                                                            v-model="biaya.bedaProvider"
                                                            @input="onNominalChange($event, 'persen_berbeda_provider')"
                                                            @hook:mounted="onMounted('berbeda_provider')"
                                                        />
                                                    </div>
                                                </div>
                                            </template>
                                        </SOTooltips>
                                        <SOTooltips>
                                            <template v-slot:tooltips>
                                                <div>
                                                    <Tooltips
                                                        keterangan="Konsumen membayar menggunakan kartu kredit."
                                                        :percent="posted.persen_kartu_kredit"
                                                    />
                                                </div>
                                            </template>
                                            <template v-slot:content>
                                                <div class="d-grid-12 m-d-12">
                                                    <div class="grid-cspan-8" style="align-self: center">
                                                        Kartu Kredit:
                                                    </div>
                                                    <div class="grid-cspan-4 has-tooltip">
                                                        <SOInputNominal
                                                            ref="kartu_kredit"
                                                            :prefix-right="true"
                                                            :use-comma="true"
                                                            :placeholder="'1'"
                                                            :use-autocomplete="false"
                                                            :max-value="dpMax"
                                                            :id="`c-card`"
                                                            :prefix="`%`"
                                                            v-model="biaya.cCard"
                                                            @input="onNominalChange($event, 'persen_kartu_kredit')"
                                                            @hook:mounted="onMounted('kartu_kredit')"
                                                        />
                                                    </div>
                                                </div>
                                            </template>
                                        </SOTooltips>
                                    </form>
                                </div>
                            </template>
                        </SOButtonExpand>
                    </div>
                    <div class="separator-line"></div>
                    <div class="p-x-20 p-t-24">
                        <SOButton
                            :primary="true"
                            :text="btnText"
                            :full="true"
                            :id="`btn-save`"
                            @action="doSave"
                            :disable="isDisabledSave"
                            :loading="isFetching"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOButton from "@/so-components/global/ui/SOButton";
import SOButtonExpand from "@/so-components/global/ui/SOButtonExpand.vue";
import SOTooltips from "@/so-components/global/ui/SOTooltips.vue";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputNominal from "@/so-components/global/input/SOInputNominal.vue";
import SoModalOptions from "@/so-components/global/ui/SOModalOptions";
import ErrorMessage from "@/component-items/ErrorMessage";

import Tooltips from "../components/Tooltips.vue";

import { minLength, required, maxValue } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "UpdateMesinEdc",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOInputRegular,
        SOButton,
        SOInputSelect,
        SOInputNominal,
        SoModalOptions,
        SOTooltips,
        SOButtonExpand,
        ErrorMessage,

        Tooltips,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "mesin.edc.update") {
                vm.loadMesinDetail();
            } else if (to.name === "mesin.edc.add") {
                vm.getIdAkun();
            }

            if (from.name === "mesin.edc.add.akun") {
                vm.backAction();
            }
        });
    },
    data() {
        return {
            dpMax: "100",
            formReady: true,
            biaya: {
                sesamaProvider: {},
                bedaProvider: {},
                cCard: {},
            },
        };
    },
    async mounted() {
        await this.setFormReady(false);
        await this.setChange(false);
        await this.resetResponse();
        await this.initPosted(this.detailMesin);
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        "posted.nama_mesin_edc": function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.setChange(true);
            }
        },
        detailMesin: function(newDt, oldDt) {
            if (newDt.idmesin_edc !== oldDt.idmesin_edc) {
                this.initPosted(newDt);
            }
        },
    },
    validations: {
        posted: {
            idakun_keuangan_edc: {
                required,
            },
            nama_mesin_edc: {
                required,
                minLength: minLength(3),
            },
            idoutlet: {
                required,
            },
            idakun_keuangan_settlement: {
                required,
            },
            idprovider: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            response: "response",
            isFetching: "isFetching",
            posted: "posted",
            listProvider: "listProvider",
            listOutlet: "listOutlet",
            listSettlement: "listSettlement",
            hasChange: "hasChange",
            detailMesin: "detailMesin",
        }),
        isDisabledSave() {
            let { idoutlet, idakun_keuangan_settlement, idprovider } = this.posted;
            let isDisabled = idoutlet ? false : true;
            isDisabled = !isDisabled && idakun_keuangan_settlement ? false : true;
            isDisabled = !isDisabled && idprovider ? false : true;
            return isDisabled;
        },
        getTitle() {
            if(this.$route.params.id_mesin){
                this.smartTrackingView("edit_mesin_edc");
            }else{
                this.smartTrackingView("add_mesin_edc");
            }

            let title = this.$route.params.id_mesin ? "Ubah Mesin EDC" : "Tambah Mesin EDC";
            return title;
        },
        btnText() {
            let text = this.$route.params.id_mesin ? "Simpan Perubahan" : "Tambahkan";
            return text;
        },
    },
    methods: {
        ...mapActions({
            getIdAkun: `${moduleName}/getIdAkun`,
            getListOutlet: `${moduleName}/getListOutlet`,
            setPosted: `${moduleName}/setPosted`,
            setSelectedPosted: `${moduleName}/setSelectedPosted`,
            setNominalPosted: `${moduleName}/setNominalPosted`,
            setChange: `${moduleName}/setChange`,
            resetResponse: `${moduleName}/resetResponse`,
            saveMesinEdc: `${moduleName}/saveMesinEdc`,
            setFetching: `${moduleName}/setFetching`,
            getDetailMesin: `${moduleName}/getDetailMesin`,
            resetListMesin: `${moduleName}/resetListMesin`,
            resetPagination: `${moduleName}/resetPagination`,
        }),
        onMounted(refItem) {
            let components = this.$refs[refItem];
            let { persen_berbeda_provider, persen_kartu_kredit, persen_sesama_edc } = this.posted;
            switch (refItem) {
                case "menu_expanded":
                    if (persen_sesama_edc || persen_kartu_kredit || persen_berbeda_provider) {
                        components.setExpand(true);
                    }
                    break;
                case "sesama_provider":
                    components.nominal = { formatted: persen_sesama_edc, raw: persen_sesama_edc.toString() };
                    break;
                case "berbeda_provider":
                    components.nominal = {
                        formatted: persen_berbeda_provider,
                        raw: persen_berbeda_provider.toString(),
                    };
                    break;
                case "kartu_kredit":
                    components.nominal = { formatted: persen_kartu_kredit, raw: persen_kartu_kredit.toString() };
                    break;
            }
        },
        initPosted(data) {
            this.setPosted(data);
        },
        back() {
            if (this.hasChange) {
                this.$router.push({ name: "mesin.edc.back.list", query: { fromRoute: this.fromRoute } });
            } else {
                this.$router.go(-1);
            }
        },
        gotoAddAkun() {
            this.$router.push({ name: "mesin.edc.add.akun" });
        },
        gotoDetail(mesinId) {
            this.$router.push({ name: "mesin.edc.detail", params: { id_mesin: mesinId } });
        },
        backAction() {
            let { optionAkun } = this.$route.query;
            if (optionAkun === "show") {
                this.$refs.modalAkun.showOptions();
            }
        },
        setFormReady(val) {
            this.formReady = val;
        },
        async loadMesinDetail() {
            await this.getListOutlet();
            if (this.detailMesin.idmesin_edc) {
                await this.setPosted(this.detailMesin);
                await this.setFormReady(true);
            } else {
                await this.getDetailMesin(this.$route.params.id_mesin);
            }
        },
        onSelectedAkun(obj, target) {
            this.setSelectedPosted({ target, val: obj.value });
            this.setChange(true);
        },
        optionSelected(e, target) {
            this.setSelectedPosted({ target, val: e });
            this.setChange(true);
        },
        onNominalChange(e, target) {
            this.setNominalPosted({ target, val: e.raw });
            this.setChange(true);
        },
        errorValidation() {
            let {
                idakun_keuangan_edc,
                nama_mesin_edc,
                idoutlet,
                idakun_keuangan_settlement,
                idprovider,
            } = this.$v.posted;
            idakun_keuangan_edc.$touch();
            nama_mesin_edc.$touch();
            idoutlet.$touch();
            idakun_keuangan_settlement.$touch();
            idprovider.$touch();

            return (
                idakun_keuangan_edc.$invalid ||
                nama_mesin_edc.$invalid ||
                idoutlet.$invalid ||
                idprovider.$invalid ||
                idakun_keuangan_settlement.$invalid
            );
        },
        doSave() {
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let posted = { ...this.posted, idedc: this.$route.params.id_mesin };

            let saving = this.saveMesinEdc(posted);
            saving
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            this.$toast.success(msg);
                            this.resetListMesin();
                            this.resetPagination();
                            this.gotoDetail(data.id);
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });

            this.smartTrackingClick("simpan_mesin_edc");

        },
    },
};
</script>

<style scoped>
.f-c-green {
    color: #24a148;
}
</style>
